import { HandleIcon } from './styles';

const DashletHandleIcon = () => {
  return (
    <HandleIcon
      icon="reorder"
      className="drag-handle"
      data-qa-id="dashlet-drag-handle"
    />
  );
};

export default DashletHandleIcon;
